import { Component, OnInit } from '@angular/core';
import { InitializationService } from '../../services/initialization.service';
import { CurrentInfoService } from '../../services/current-info.service';
import { WorkWeekService } from '../../services/work-week.service';
import { AppConfigService } from '../../services/app-config.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { CustomerService } from 'src/app/services/customer.service';
import { CurrentOrderService } from 'src/app/services/current-order.service';
import { Title, Meta } from '@angular/platform-browser';
import { LocaleService } from 'src/app/services/locale.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MatDialog } from '@angular/material/dialog';
import { SummaryDialogComponent } from '../dialogs/summary-dialog/summary-dialog.component';
import { AnalyticsService as AnalyticsService } from 'src/app/services/analytics.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { StoreHistoryService } from 'src/app/services/store-history-service.service';
import { CouponsService } from 'src/app/services/coupons.service';

@Component({
  selector: 'app-store-home',
  templateUrl: './store-home.component.html',
  styleUrls: ['./store-home.component.scss'],
})
export class StoreHomeComponent implements OnInit {
  constructor(
    private initializationservice: InitializationService,
    private currentinfoservice: CurrentInfoService,
    private workweekservice: WorkWeekService,
    private appconfigservice: AppConfigService,
    private route: ActivatedRoute,
    private router: Router,
    private customerservice: CustomerService,
    private currentorderservice: CurrentOrderService,
    private meta: Meta,
    private title: Title,
    private localeservice: LocaleService,
    private authenticationservice: AuthenticationService,
    public alertDialog: MatDialog,
    private analyticsservice: AnalyticsService,
    private historyservice: StoreHistoryService,
    private couponsservice: CouponsService
  ) {}

  public imageSource: string = 'assets/img/placeholder.png';
  public worktimeString: string = '';
  public orderNowString: string = '';
  public appButtonString: string = '';
  public myProfileButtonString: string = '';
  public isLoading: boolean = true;
  public isError: boolean = false;
  public isSuccess: boolean = false;
  public showProfile: boolean = false;
  public showApp: boolean = false;
  public showCoupons: boolean = false;

  errortitle = 'Ops';
  errormessage = 'Er...';
  errorbutton = '!!!';
  isOutdated = false;

  _orderPhoneUrl: string = '';

  goto: string = '';

  ngOnInit(): void {
    this.setErrorMessage();

    this.getData();
  }

  async getData() {
    try {
      this.isLoading = true;

      var param = this.route.snapshot.paramMap.get('appname');

      if (param !== null && param !== undefined && param !== '') {
        if (param === 'juras') {
          this.isOutdated = true;
        } else if (param === 'dodas') {
          this._orderPhoneUrl =
            'https://whatsa.me/5517996832100/?t=Ol%C3%A1,%20quero%20fazer%20um%20pedido';
        }

        let result = await this.initializationservice.Initialize(param);

        if (result) {
          this.historyservice.placeEntry();

          this.imageSource = this.currentinfoservice._currentInfo.Icon;

          var placeName = this.appconfigservice.getPlaceName();

          this.title.setTitle(placeName);

          this.meta.updateTag({
            property: 'og:image',
            content: this.imageSource,
          });
          this.meta.updateTag({
            property: 'og:title',
            content: this.appconfigservice.getPlaceName(),
          });
          this.meta.updateTag({ property: 'og:url', content: this.router.url });
          this.meta.updateTag({
            property: 'og:description',
            content: 'Faça seu pedido.',
          });

          this.appButtonString = await this.localeservice.getTranslation(
            'Pages.Storehome.AppButton'
          );
          this.myProfileButtonString = await this.localeservice.getTranslation(
            'Pages.Storehome.ProfileButton'
          );

          if (
            this.workweekservice.isOpen() &&
            this.currentinfoservice.isOpen()
          ) {
            this.worktimeString = await this.localeservice.getTranslation(
              'Pages.Storehome.Open.Message'
            );
            this.orderNowString = await this.localeservice.getTranslation(
              'Pages.Storehome.Open.MenuButton'
            );

            var coupons = this.couponsservice.getCoupons();

            this.showCoupons = coupons.length > 0;
          } else {
            if (!this.currentinfoservice.isOpen())
              this.worktimeString =
                await this.currentinfoservice.getClosedMessage();
            else
              this.worktimeString = await this.localeservice.getTranslation(
                'Pages.Storehome.Closed.Message'
              );

            this.orderNowString = await this.localeservice.getTranslation(
              'Pages.Storehome.Closed.MenuButton'
            );
          }

          this.showApp = this.appconfigservice.hasApp();
          this.showProfile = this.customerservice.hasCustomerData();

          this.isSuccess = true;

          if (this.currentorderservice.getShowOrderSent()) {
            this.showOrderSent();

            this.isLoading = false;

            return;
          }

          var goto = String(this.route.snapshot.queryParamMap.get('goto'));

          if (goto.startsWith('combo')) {
            var comboID = goto.substring(5);

            var appname = String(this.route.snapshot.paramMap.get('appname'));

            this.router.navigateByUrl(
              '/' +
                appname +
                '/combo/' +
                comboID +
                '?status=new&isredirect=true'
            );

            return;
          }

          if (goto.startsWith('item')) {
            var itemID = goto.substring(4);

            var appname = String(this.route.snapshot.paramMap.get('appname'));

            this.router.navigateByUrl(
              '/' +
                appname +
                '/menuitem/' +
                itemID +
                '?status=new&isredirect=true'
            );

            return;
          }
        } else {
          this.worktimeString = '';
        }
      } else {
        this.worktimeString = '';
      }
      this.isLoading = false;
    } catch (error) {
      console.error(error);

      this.isLoading = false;
      this.isError = true;
    }
  }

  setErrorMessage() {
    var locale = this.getUsersLocale('pt');

    switch (locale) {
      case 'pt':
        this.errortitle = 'Ops';
        this.errormessage =
          'Algo deu errado, verifique sua conexão e tente novamente.';
        this.errorbutton = 'Tentar Novamente';
        break;
      case 'en':
        this.errortitle = 'Ops';
        this.errormessage =
          'Something went wrong, verify your conection and try again.';
        this.errorbutton = 'Try Again';
        break;
      default:
        this.errortitle = 'Ops';
        this.errormessage =
          'Something went wrong, verify your conection and try again.';
        this.errorbutton = 'Try Again';
        break;
    }
  }

  getUsersLocale(defaultValue: string): string {
    if (
      typeof window === 'undefined' ||
      typeof window.navigator === 'undefined'
    )
      return defaultValue;

    const wn = window.navigator as any;

    let lang = wn.languages ? wn.languages[0] : defaultValue;

    lang = lang || wn.language || wn.browserLanguage || wn.userLanguage;

    let langString = String(lang);

    let dashIndx = langString.indexOf('-');

    if (dashIndx > -1) langString = langString.split('-', 2)[0];

    return langString;
  }

  tryAgain() {
    this.isError = false;

    this.getData();
  }

  showOrderSent() {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    this.router.navigateByUrl('/' + appname + '/ordersent');
  }

  openApp() {
    this.analyticsservice.facebookTrack('DownloadApp');
    this.analyticsservice.track('DownloadApp', {
      path: this.initializationservice._appName,
    });

    let link = this.appconfigservice.getAppUrl();

    if (link !== '') window.open(link, '_top');
  }

  orderNow() {
    this.analyticsservice.facebookTrack('OrderNow', undefined);
    this.analyticsservice.track('OrderNow');

    this.currentorderservice.clear();
    this.currentorderservice.setPayCardData({
      hasPayCard: 0,
      payCardNumber: 0,
    });
    this.router.navigateByUrl(
      '/' + this.initializationservice._appName + '/ordertype'
    );
  }

  seeProfile() {
    this.router.navigateByUrl(
      '/' + this.initializationservice._appName + '/myprofile'
    );
  }

  async loginGoogle() {
    try {
      var credentials = await this.authenticationservice.loginViaGoogle();
    } catch (error) {
      console.error(error);
    }
  }

  async logoutGoogle() {
    try {
      if ((await this.authenticationservice.isLoggedIn()) !== null) {
        this.authenticationservice.logout();
      }
    } catch (error) {
      console.error(error);
    }
  }

  showWorkTime() {
    this.alertDialog.open(SummaryDialogComponent, {
      height: 'fit-content',
      width: 'fit-content',
      data: {
        title: this.localeservice.instantTranslation(
          'Dialogs.Summary.WorkTimeSummary.Title'
        ),
        detail: this.workweekservice.getWorkWeekSummary(),
        accept: this.localeservice.instantTranslation(
          'Dialogs.Summary.WorkTimeSummary.Accept'
        ),
      },
    });
  }

  contactUs() {
    this.router.navigateByUrl('');
  }

  getSupport() {
    window.open(
      'https://whatsa.me/5517997847439/?t=Ola,%20estou%20acessando%20uma%20vers%C3%A3o%20antiga%20do%20app.%20Pode%20me%20ajudar?',
      '_blank'
    );
  }

  orderPhone() {
    window.open(this._orderPhoneUrl, '_blank');
  }
}
